import React, {
  lazy,
  Suspense,
  useEffect,
  useMemo,
  useRef,
  useState,
  MouseEvent,
} from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import UploadIcon from '@mui/icons-material/Upload';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import BrowserUpdatedIcon from '@mui/icons-material/BrowserUpdated';
import Form from "react-bootstrap/Form";
import "./InputBox.scss";
import HistoryIcon from '@mui/icons-material/History';

import {
  MaterialReactTable,
  MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_DensityState,
  type MRT_Row,
  MRT_SortingState,
  MRT_TableOptions,
  MRT_VisibilityState,
  useMaterialReactTable,
} from "material-react-table";
import {
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  Tooltip,
} from "@mui/material";
import {
  QueryClient,
  QueryClientProvider,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import { ReactQueryDevtools as ReactQueryDevtoolsProduction } from "@tanstack/react-query-devtools";

import { fakeData, usStates } from "./makeData";
import { citiesList, usStateList } from "./makeData";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Accordion from "react-bootstrap/Accordion";
import Table from "react-bootstrap/Table";
import { Col, Container, Row } from "reactstrap";
import axiosInstance from "../../Utils/axiosInstance";
import { backendbaseUrl } from "../../Utils/baseUrl";
import { StyledTableFirstSecond } from "../Book/TableBook";
import { showDeleteConfirmModal } from "../../Components/ConfirmModal";
import { CompactTextField } from "../../Components/SharedComponents/SharedComponents";
import { toast } from "react-toastify";
import FileUpload from "../../Components/FileUpload/FileUpload";
import BrokerTemplateDownloadButton from "../../Components/TemplateDownloadButton/BrokerTemplateDownloadButton";
import { useNavigate } from "react-router-dom";
interface User {
  id: string;
  name: string;
}
const Example = () => {
  const [validationErrors, setValidationErrors] = useState<
    Record<string, string | undefined>
  >({});
  const isFirstRender = useRef(true);
  const [filterModes, setFilterModes] = useState<
    { mode: string; id: string; value: unknown }[]
  >([]);
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [columnVisibility, setColumnVisibility] = useState<MRT_VisibilityState>(
    {}
  );
  const [density, setDensity] = useState<MRT_DensityState>("comfortable");
  const [globalFilter, setGlobalFilter] = useState<string | undefined>(
    undefined
  );
  const [showGlobalFilter, setShowGlobalFilter] = useState(true);
  const [showColumnFilters, setShowColumnFilters] = useState(true);
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [clearerName, setClearerName] = useState<string>(""); // Changed from brokerName
  const [inputBackgroundColour, setInputBackgroundColour] = useState("");
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 15,
  });
  const addButtonRef = useRef<HTMLButtonElement | null>(null);
  const [showRowResizing, setShowRowResizing] = useState<boolean>(true);
  const [totalCount, setTotalCount] = useState(0);

  const [openFileUpload, setOpenFileUpload] = useState<boolean>(false);
  const handleFileUploadOpen = () => setOpenFileUpload(true);
  const handleFileUploadClose = () => setOpenFileUpload(false);

  const handleFileUploadSubmit = async (file: File) => {
    const formData = new FormData();
    formData.append("file", file); // The key should match your API expectation

    try {
      const response = await axiosInstance.post(
        `${backendbaseUrl}/paper-app/upload/clearer/`, // Update endpoint
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Refresh table data after successful upload
      queryClient.invalidateQueries({ queryKey: ["users"] });

      return {
        success: true,
        message: "File uploaded and data added successfully!",
        data: response.data,
      };
    } catch (error: any) {
      return {
        success: false,
          message: error.response?.data?.error || error.response?.data?.message || "Failed to upload file",

      };
    }
  };

  const navigate = useNavigate();
  const handlehistory = () => {
    navigate('/settings/log/history/clearer')
  }
  useEffect(() => {
    // Existing localStorage logic remains unchanged
    const columnFilters = localStorage.getItem("mrt_columnFilters_table_1");
    const columnVisibility = localStorage.getItem(
      "mrt_columnVisibility_table_1"
    );
    const density = localStorage.getItem("mrt_density_table_1");
    const globalFilter = localStorage.getItem("mrt_globalFilter_table_1");
    const showGlobalFilter = localStorage.getItem(
      "mrt_showGlobalFilter_table_1"
    );
    const showColumnFilters = localStorage.getItem(
      "mrt_showColumnFilters_table_1"
    );
    const sorting = localStorage.getItem("mrt_sorting_table_1");

    if (columnFilters) setColumnFilters(JSON.parse(columnFilters));
    if (columnVisibility) setColumnVisibility(JSON.parse(columnVisibility));
    if (density) setDensity(JSON.parse(density));
    if (globalFilter) setGlobalFilter(JSON.parse(globalFilter) || undefined);
    if (showGlobalFilter) setShowGlobalFilter(JSON.parse(showGlobalFilter));
    if (showColumnFilters) setShowColumnFilters(JSON.parse(showColumnFilters));
    if (sorting) setSorting(JSON.parse(sorting));
    isFirstRender.current = false;
  }, []);

  // Save states to localStorage (unchanged)
  useEffect(() => {
    if (isFirstRender.current) return;
    localStorage.setItem(
      "mrt_columnFilters_table_1",
      JSON.stringify(columnFilters)
    );
  }, [columnFilters]);

  useEffect(() => {
    if (isFirstRender.current) return;
    localStorage.setItem(
      "mrt_columnVisibility_table_1",
      JSON.stringify(columnVisibility)
    );
  }, [columnVisibility]);

  useEffect(() => {
    if (isFirstRender.current) return;
    localStorage.setItem("mrt_density_table_1", JSON.stringify(density));
  }, [density]);

  useEffect(() => {
    if (isFirstRender.current) return;
    localStorage.setItem(
      "mrt_globalFilter_table_1",
      JSON.stringify(globalFilter ?? "")
    );
  }, [globalFilter]);

  useEffect(() => {
    if (isFirstRender.current) return;
    localStorage.setItem(
      "mrt_showGlobalFilter_table_1",
      JSON.stringify(showGlobalFilter)
    );
  }, [showGlobalFilter]);

  useEffect(() => {
    if (isFirstRender.current) return;
    localStorage.setItem(
      "mrt_showColumnFilters_table_1",
      JSON.stringify(showColumnFilters)
    );
  }, [showColumnFilters]);

  useEffect(() => {
    if (isFirstRender.current) return;
    localStorage.setItem("mrt_sorting_table_1", JSON.stringify(sorting));
  }, [sorting]);

  const columns = useMemo<MRT_ColumnDef<User>[]>(
    () => [
      {
        accessorKey: "name",
        header: "Clearer Name", // Changed from "Broker Name"
        enableEditing: true,
        muiTableBodyCellProps: ({ row, table }) => ({
          onDoubleClick: () => {
            table.setEditingRow(row);
          },
          sx: {
            height: "10px",
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "rgba(44, 4, 4, 0.05)",
            },
            ...(table.getState().editingRow?.id === row.id && {
              backgroundColor: "rgba(0, 128, 0, 0.1)",
              transition: "background-color 0.3s ease",
            }),
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
        }),
        muiEditTextFieldProps: {
          name: "name",
          required: true,
          error: !!validationErrors?.name,
          helperText: validationErrors?.name,
          onFocus: () =>
            setValidationErrors((prev) => ({
              ...prev,
              name: undefined,
            })),
        },
      },
    ],
    [validationErrors]
  );

  const { mutateAsync: createUser, isPending: isCreatingUser } =
    useCreateUser();
  const {
    data,
    isError: isLoadingUsersError,
    isFetching: isFetchingUsers,
    isLoading: isLoadingUsers,
  } = useGetData(filterModes, pagination, setTotalCount, sorting);
  const { mutateAsync: updateUser, isPending: isUpdatingUser } =
    useUpdateUser();
  const { mutateAsync: deleteUser, isPending: isDeletingUser } =
    useDeleteUser();

  // CREATE FUNCTION TO ADD NEW CLEARER
  const createClearer = async (clearer: { id: string; name: string }) => {
    const errors = validateUser({ id: clearer.id, name: clearer.name });

    if (Object.values(errors).some((error) => error)) {
      setValidationErrors({
        clearerName: errors.name,
      });
      toast.error(errors.name);
      return;
    }

    try {
      await axiosInstance.post(
        `${backendbaseUrl}/paper-app/clearers/`,
        clearer
      );
      queryClient.invalidateQueries({ queryKey: ["users"] });
      setValidationErrors({}); // Clear errors on success
      toast.success("Clearer added successfully!"); // Plain JS alert
    } catch (error) {
      console.error("Error adding clearer:", error);
      toast.error("Failed to add clearer. Please try again."); // Plain JS alert
    }
  };

  // Create by submitting the form
  const formCreate = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const clearer = {
      id: Date.now().toString(),
      name: clearerName.trim(), // Changed from brokerName
    };

    await createClearer(clearer);
    setClearerName("");
  };

  // CREATE action
  const handleCreateUser: MRT_TableOptions<User>["onCreatingRowSave"] = async ({
    values,
    table,
  }) => {
    const newValidationErrors = validateUser(values);
    if (Object.values(newValidationErrors).some((error) => error)) {
      setValidationErrors(newValidationErrors);
      return;
    }

    setValidationErrors({});

    const clearer = {
      id: Date.now().toString(),
      name: values.name.trim(),
    };

    await createClearer(clearer);
    table.setCreatingRow(null);
  };

  // UPDATE action
  const handleEditSave: MRT_TableOptions<User>["onEditingRowSave"] = async ({
    values,
    table,
    row,
  }) => {
    console.log("Saving Clearer - Full Row Original Data:", row.original);
    console.log("Saving Clearer - Edited Values:", values);

    const updatedClearer = {
      ...row.original,
      ...values,
    };

    const newValidationErrors = validateUser(updatedClearer);
    if (Object.values(newValidationErrors).some((error) => error)) {
      console.log("Validation Errors:", newValidationErrors);
      setValidationErrors(newValidationErrors);
      return;
    }

    setValidationErrors({});

    try {
      await updateUser(updatedClearer);
      table.setEditingRow(null);
      toast.success("Clearer updated successfully!"); // Plain JS alert
    } catch (error) {
      console.error("Clearer Update Error:", error);
      toast.error("Failed to update clearer. Please try again."); // Plain JS alert
    }
  };

  // DELETE action
  const openDeleteConfirmModal = (row: MRT_Row<User>) => {
    showDeleteConfirmModal({
      title: "Are you sure you want to delete this clearer?",
      content: `Deleting ... `,
      onOk: () => {
        deleteUser(row.original.id)
          .then(() => {
            toast.success("Clearer deleted successfully!"); // Plain JS alert
          })
          .catch((error) => {
            toast.error("Failed to delete clearer. Please try again."); // Plain JS alert
          });
      },
    });
  };

  // Copy row handler
  const handleCopyRow = (row: any) => {
    if (!row) return;
    const rowData = row.original;
    let textToCopy = JSON.stringify(rowData, null, 2);
    navigator.clipboard.writeText(textToCopy);

    try {
      const jsonData = JSON.parse(textToCopy);
      setClearerName(jsonData.name);
      window.scrollTo({ top: 0, behavior: "smooth" });
      setInputBackgroundColour("#83bf6e26");
      setTimeout(() => {
        setInputBackgroundColour("");
      }, 2400);
      toast.success("Copied and pasted successfully!"); // Plain JS alert
    } catch (error) {
      console.error("Invalid JSON. Pasted as a string:", textToCopy);
      toast.error("Failed to parse copied data."); // Plain JS alert
    }
  };

  // Context menu handling
  interface ContextMenuPosition {
    mouseX: number;
    mouseY: number;
  }

  const [contextMenu, setContextMenu] = useState<ContextMenuPosition | null>(
    null
  );

  const handleContextMenu = (event: MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    setContextMenu(
      contextMenu === null
        ? { mouseX: event.clientX + 2, mouseY: event.clientY - 6 }
        : null
    );
  };

  const handleClose = () => {
    setContextMenu(null);
  };

  const handlePaste = async () => {
    try {
      const text = await navigator.clipboard.readText();
      let jsonData;

      try {
        jsonData = JSON.parse(text);
        setClearerName(jsonData.name);
        window.scrollTo({ top: 0, behavior: "smooth" });
        setInputBackgroundColour("#83bf6e26");
        setTimeout(() => {
          setInputBackgroundColour("");
        }, 2400);
        toast.error("Pasted successfully!"); // Plain JS alert
      } catch (error) {
        console.error("Invalid JSON. Pasted as a string:", text);
        toast.error("Failed to parse pasted data."); // Plain JS alert
      }
    } catch (err) {
      console.error("Failed to read clipboard contents:", err);
      toast.error("Failed to read clipboard contents."); // Plain JS alert
    }
    handleClose();
  };

  const handleResizing = () => {
    setShowRowResizing(!showRowResizing);
    handleClose();
  };

 const handleExportRows = async (rows: MRT_Row<any>[]) => {
    if (rows.length === 0) {
      toast.warn("Please select at least one row to export");
      return;
    }

    try {
      const rowIds = rows.map((row) => row.original.id);
      const response = await axiosInstance.post(
        `${backendbaseUrl}/paper-app/clearers/select-export/`,
        { ids: rowIds },
        {
          responseType: "blob",
        }
      );

      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "selected_clearers.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      toast.success("Export started successfully");
    } catch (error) {
      console.error("Export error:", error);
      toast.error("Failed to export selected rows");
    }
  };

  const handleDataDownload = async () => {
    try {
      const response = await axiosInstance.post(
        `${backendbaseUrl}/paper-app/clearers/select-export/`,
        {
          responseType: "blob",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.data) {
        throw new Error("No data received from server");
      }

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "all_clearers.csv");
      document.body.appendChild(link);
      link.click();

      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);

      toast.success("All data download started"); // Plain JS alert
    } catch (error) {
      console.error("Download error:", error);
      toast.error("Failed to download all data"); // Plain JS alert
    }
  };

  const handleBulkDelete = async (rows: MRT_Row<any>[]) => {
    const rowIds = rows.map((row) => row.original.id);

    if (rowIds.length === 0) {
      toast.warning("Please select at least one clearer to delete."); // Plain JS alert
      return;
    }

    console.log("Selected IDs for deletion:", rowIds);

    try {
      showDeleteConfirmModal({
        title: `Delete ${rowIds.length} selected clearer(s)?`,
        content: `This will permanently delete ${rowIds.length} clearer(s). Continue?`,
        onOk: async () => {
          const payload = {
            ids: rowIds.filter((id) => id),
          };
          console.log("Sending delete payload:", payload);

          try {
            const response = await axiosInstance.delete(
              `${backendbaseUrl}/paper-app/clearers/export-delete/`,
              {
                data: payload,
                headers: {
                  "Content-Type": "application/json",
                  "X-Requested-With": "XMLHttpRequest",
                },
              }
            );

            if (response.status === 200) {
              toast.success(`Successfully deleted ${rowIds.length} clearer(s)`); // Plain JS alert
              queryClient.invalidateQueries({ queryKey: ["users"] });
              table.setRowSelection({});
            } else {
              throw new Error(
                response.data?.message || "Unknown error occurred"
              );
            }
          } catch (error: any) {
            console.error("Delete error details:", {
              message: error.message,
              response: error.response?.data,
              status: error.response?.status,
            });

            const errorMessage =
              error.response?.data?.detail ||
              error.response?.data?.message ||
              error.message ||
              "Failed to delete clearers";
            toast.error(`Deletion failed: ${errorMessage}`); // Plain JS alert
          }
        },
      });
    } catch (error) {
      console.error("Confirmation dialog error:", error);
      toast.error("An error occurred during the deletion process."); // Plain JS alert
    }
  };

  const table = useMaterialReactTable({
    columns,
    enableStickyHeader: true,
    enableStickyFooter: true,
    enableClickToCopy: true,
    enableKeyboardShortcuts: true,
    enableColumnActions: true,
    enableColumnDragging: true,
    enableGlobalFilter: false,
    enableGrouping: true,
    enableHiding: true,
    enableSorting: true,
    enableColumnPinning: true,
    onPaginationChange: setPagination,
    onColumnFiltersChange: setColumnFilters,
    onColumnVisibilityChange: setColumnVisibility,
    onDensityChange: setDensity,
    onGlobalFilterChange: setGlobalFilter,
    onShowColumnFiltersChange: setShowColumnFilters,
    onShowGlobalFilterChange: setShowGlobalFilter,
    onSortingChange: setSorting,
    manualSorting: true,
    manualPagination: true,
    enableRowSelection: true,
    // positionToolbarAlertBanner: "bottom",
    // layoutMode: "semantic",
    // enableColumnResizing: showRowResizing,
    enableColumnResizing: true, // Already set
    // columnResizeMode: "onEnd", // Ensures precise resizing
    // defaultColumn: {
    //   minSize: 50, // Smallest practical width
    //   enableResizing: true,
    // },
    enableFilterMatchHighlighting: true,
    rowCount: totalCount,
    manualFiltering: true,
    data: data?.results || [],
    enableDensityToggle: false,
    createDisplayMode: "row",
    editDisplayMode: "row",
    enableEditing: true,

    // Top toolbar customization
    muiTopToolbarProps: ({ table }) => ({
      sx: {
        backgroundColor: "#fff",
        padding: "8px",
        // Optional: Style the inner MuiBox-root (css-wsew38) for visual confirmation
        "& .MuiBox-root.css-wsew38": {
          backgroundColor: "#fff",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        },
      },
      className: "top-toolbar-wrapper__new",
    }),

    muiTableContainerProps: ({ table }) => ({
      sx: {
        backgroundColor: "#fff",
      },
      className: "table-container-wrapper__new",
    }),
    muiTableFooterProps: ({ table }) => ({
      sx: {
        backgroundColor: "#fff",
      },
      className: "table-footer-wrapper__new",
    }),
    muiBottomToolbarProps: ({ table }) => ({
      sx: {
        backgroundColor: "#fff",
        padding: "8px",
      },
      className: "bottom-toolbar-wrapper__new",
    }),

    muiTableBodyRowProps: ({ row, table }) => ({
      onKeyDown: (event: React.KeyboardEvent<HTMLTableRowElement>) => {
        if (event.key === "Enter") {
          event.preventDefault();
          const editingRow = table.getState().editingRow;
          if (editingRow) {
            const saveHandler = table.options.onEditingRowSave;
            if (saveHandler) {
              const newEdit = {
                ...editingRow.original,
                ...editingRow._valuesCache,
              };
              console.log("Saving:", newEdit);
              saveHandler({
                exitEditingMode: () => table.setEditingRow(null),
                row: editingRow,
                table,
                values: newEdit,
              });
            }
          }
        }
      },
    }),
    enableColumnOrdering: true,
    enableRowOrdering: false,
    getRowId: (row) => row.id,
    enableColumnFilterModes: true,
    initialState: { showColumnFilters: showColumnFilters  },
    filterFns: {
      customFilterFn: (row, id, filterValue) => {
        return row.getValue(id) === filterValue;
      },
    },
    // defaultDisplayColumn: {
    //   enableResizing: true,
    // },
    displayColumnDefOptions: {
      "mrt-row-actions": {
        enableColumnActions: true,
        size: 120,
        muiTableHeadCellProps: {
          // align: "center",
        },
      },
      "mrt-row-numbers": {
        enableColumnDragging: true,
        enableColumnOrdering: true,
        // enableResizing: true,
        muiTableHeadCellProps: {
          sx: {
            fontSize: "1.2rem",
          },
        },
      },
      "mrt-row-select": {
        enableColumnActions: true,
        enableHiding: true,
        // size: 50,
      },
    },
    renderTopToolbarCustomActions: ({ table }) => (
      <Box
        className="table-download__wrapper"
        sx={{
          display: "flex",
          gap: "6px",
          padding: "0px",
          flexWrap: "wrap",
        }}
      >
        <Button startIcon={<UploadFileIcon />} onClick={handleFileUploadOpen}>
          Upload File
        </Button>

        <Button
          onClick={() => handleDataDownload()}
          startIcon={<BrowserUpdatedIcon />}
        >
          Export All Data
        </Button>
        <BrokerTemplateDownloadButton
          apiEndpoint="/paper-app/download-clearer-template/"
          buttonText="Download Template"
          fileName="clearer_template.csv"
        />
                <Button
          //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
          onClick={() => handlehistory()}
          startIcon={<HistoryIcon />}
        >
          history
        </Button>
        <Button
          disabled={
            !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
          }
          onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
          startIcon={<FileDownloadIcon />}
        >
          Export Selected Rows
        </Button>
        {(table.getIsSomeRowsSelected() || table.getIsAllRowsSelected()) && (
          <Button
            style={{ color: "red" }}
            onClick={() => handleBulkDelete(table.getSelectedRowModel().rows)}
            startIcon={<DeleteIcon />}
          >
            Delete Selected ({table.getSelectedRowModel().rows.length})
          </Button>
        )}
      </Box>
    ),
    muiTableHeadCellProps: {
      sx: {
        border: "1px solid #e0e0e087",
        fontStyle: "normal",
        fontWeight: "normal",
      },
    },
    muiTablePaperProps: {
      elevation: 0,
      sx: {
        borderRadius: "0",
        border: "0",
      },
    },
    localization: {
      filterCustomFilterFn: "Custom Filter Fn",
    } as any,
    muiToolbarAlertBannerProps: isLoadingUsersError
      ? {
        color: "error",
        children: "Error loading data",
      }
      : undefined,

    onCreatingRowCancel: () => setValidationErrors({}),
    onCreatingRowSave: handleCreateUser,
    onEditingRowCancel: () => setValidationErrors({}),
    onEditingRowSave: handleEditSave,
    renderRowActions: ({ row, table }) => (
      <Box
      //  sx={{ display: "flex", gap: "1rem" }}
      >
        <Tooltip title="Edit" className="editIcon">
          <IconButton onClick={() => table.setEditingRow(row)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete" className="deleteIcon">
          <IconButton color="error" onClick={() => openDeleteConfirmModal(row)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Copy Row">
          <IconButton onClick={() => handleCopyRow(row)}>
            <ContentCopyIcon />
          </IconButton>
        </Tooltip>
      </Box>
    ),
    state: {
      columnVisibility,
      sorting,
      columnFilters,
      pagination,
      isLoading: isLoadingUsers,
      isSaving: isCreatingUser || isUpdatingUser || isDeletingUser,
      showAlertBanner: isLoadingUsersError,
      showProgressBars: isFetchingUsers,
      showColumnFilters: showColumnFilters,
    },
  });

  useEffect(() => {
    const transformedFilters = columnFilters.map((filter) => ({
      ...filter,
      mode: table.getColumn(filter.id)?.getFilterFn()?.name || "contains",
    }));
    setFilterModes(transformedFilters);
  }, [columnFilters, table]);

  return (
    <div className="page-body">
      <Container fluid>
        <Row>
          <div>
            <div className="table-ad">
              <Accordion defaultActiveKey="0" className="table-ad__addInputs">
                <Accordion.Item eventKey="0">
                  <Accordion.Header className="accordion_button">
                    Add New Clearer
                  </Accordion.Header>
                  <Accordion.Body>
                    <Form onSubmit={formCreate}>
                      <div className="form_contain">
                        <div
                          className={`flex formWrapper ${inputBackgroundColour !== "" ? "inputboxcustom" : ""
                            }`}
                          style={{ backgroundColor: inputBackgroundColour }}
                        >
                          <Box
                            sx={{
                              width: "100%",
                              p: { xs: 1, sm: 1 },
                              pt: "20px !important",
                              backgroundColor: "#ffff",
                              borderRadius: "4px",
                              border: "1px solid #e0e0e0",
                            }}
                          >
                            <Box
                              className="form_default"
                              sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "flex-start",
                                justifyContent: "start",
                                gap: 0.5,
                                "& > *": {
                                  minWidth: {
                                    xs: "100%",
                                    sm: "48%",
                                    md: "23%",
                                    lg: "15%",
                                    xl: "7.5%",
                                  },
                                },
                              }}
                            >
                              <CompactTextField
                                label="Enter Clearer"
                                value={clearerName}
                                onChange={(value) => setClearerName(value)}
                                name="clearerName"
                                error={Boolean(validationErrors.clearerName)}
                                helperText={validationErrors.clearerName}
                                validateOnBlur={(value) => {
                                  const error = validateRequired(value)
                                    ? ""
                                    : "Clearer name is required";
                                  setValidationErrors((prev) => ({
                                    ...prev,
                                    clearerName: error,
                                  }));
                                  return error;
                                }}
                                slotProps={{
                                  inputLabel: {
                                    shrink: true,
                                  },
                                }}
                                onFocus={() => {
                                  setValidationErrors((prev) => ({
                                    ...prev,
                                    clearerName: undefined,
                                  }));
                                }}
                                sx={{
                                  maxWidth: { sm: "250px", xs: "100%" },
                                }}
                              />
                              <Button
                                variant="contained"
                                fullWidth
                                type="submit"
                                sx={{
                                  height: { xs: "36px", sm: "32px" },
                                  flex: { xs: "1 1 auto", sm: "0 0 auto" },
                                  minWidth: { xs: "100%", sm: "100px" },
                                  maxWidth: { sm: "150px" },
                                  backgroundColor: "#00bcd4",
                                  textTransform: "none",
                                  fontSize: "0.75rem",
                                  "&:hover": {
                                    backgroundColor: "#008c9e",
                                  },
                                }}
                              >
                                Add
                              </Button>
                            </Box>
                          </Box>
                        </div>
                      </div>
                    </Form>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
              <div
                className="table-ad__wrapper"
                onContextMenu={handleContextMenu}
              >
                <div className="table-ad__wrapperCard">
                  <MaterialReactTable table={table} />

                  <Menu
                    open={contextMenu !== null}
                    onClose={handleClose}
                    anchorReference="anchorPosition"
                    anchorPosition={
                      contextMenu !== null
                        ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                        : undefined
                    }
                  >
                    <MenuItem onClick={handleResizing}>
                      {showRowResizing ? "Disable Resizing" : "Enable Resizing"}
                    </MenuItem>
                  </Menu>
                </div>
                <FileUpload
                  open={openFileUpload}
                  onFileUploadClose={handleFileUploadClose}
                  onFileUploadSubmit={handleFileUploadSubmit}
                  acceptedFileTypes=".csv,.json"
                />
              </div>
            </div>
          </div>
        </Row>
      </Container>
    </div>
  );
};

// CREATE hook
function useCreateUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (user: User) => {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      return Promise.resolve();
    },
    onMutate: (newUserInfo: User) => {
      queryClient.setQueryData(
        ["users"],
        (prevUsers: any) =>
          [
            ...prevUsers,
            {
              ...newUserInfo,
              id: (Math.random() + 1).toString(36).substring(7),
            },
          ] as User[]
      );
    },
  });
}

// READ hook
function useGetData(
  filterModes: { mode: string; id: string; value: unknown }[],
  pagination: { pageIndex: number; pageSize: number },
  setTotalCount: any,
  sorting: any
) {
  return useQuery<{ results: User[]; totalCount: number }>({
    queryKey: ["users", filterModes, pagination, sorting],
    queryFn: async () => {
      let url = `${backendbaseUrl}/paper-app/clearers/?page=${pagination.pageIndex + 1
        }&page_size=${pagination.pageSize}`;

      if (filterModes.length > 0) {
        const queryParams = filterModes
          .map(
            (e) =>
              `fieldName__d39d26f3-8442-44d0-8a7f-66cfcbb2c781__${e.id
              }=${String(e.value)}__d39d26f3-8442-44d0-8a7f-66cfcbb2c781__${e.mode
              }`
          )
          .join("&");
        url += `&${queryParams}`;
      }

      if (sorting.length > 0) {
        const sortParams = `sortField_${sorting[0].id}=${sorting[0].desc}_sorting`;
        url += `&${sortParams}`;
      }

      const response = await axiosInstance.get(url);
      setTotalCount(response.data.count);
      return {
        results: response.data.results as User[],
        totalCount: response.data.count as number,
      };
    },
    refetchOnWindowFocus: false,
  });
}

// UPDATE hook
function useUpdateUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (user: User) => {
      console.group("🔄 Clearer Update Mutation");
      console.log("Input Clearer Object:", user);

      if (!user || !user.id) {
        console.error("❌ Invalid clearer object:", user);
        throw new Error("Clearer object is invalid or missing ID");
      }

      const payload = user;
      console.log("📦 Prepared Payload:", payload);
      console.groupEnd();

      try {
        const { data } = await axiosInstance.put(
          `/paper-app/clearers/${payload.id}/`,
          user
        );
        console.log("✅ API Response:", data);
        return data;
      } catch (error) {
        console.error("❌ API Request Failed:", error);
        throw error;
      }
    },
    onMutate: async (newUserInfo: User) => {
      console.log("🔮 Optimistic Update - New Clearer Info:", newUserInfo);
      await queryClient.cancelQueries({ queryKey: ["users"] });
      const previousUsers = queryClient.getQueryData(["users"]);
      queryClient.setQueryData(["users"], (oldData: any) =>
        oldData?.map((prevUser: User) =>
          prevUser.id === newUserInfo.id ? newUserInfo : prevUser
        )
      );
      return { previousUsers };
    },
    onError: (err, newUser, context) => {
      console.error("❌ Update Failed:", err);
      queryClient.setQueryData(["users"], context?.previousUsers);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["users"] });
    },
  });
}

// DELETE hook
function useDeleteUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (userId: string) => {
      await axiosInstance.delete(
        `${backendbaseUrl}/paper-app/clearers/${userId}/`
      );
    },
    onMutate: async (userId: string) => {
      await queryClient.cancelQueries({ queryKey: ["users"] });
      const previousUsers = queryClient.getQueryData<User[]>(["users"]);
      queryClient.setQueryData(["users"], (oldUsers: User[] | undefined) =>
        oldUsers?.filter((user) => user.id !== userId)
      );
      return { previousUsers };
    },
    onError: (err, userId, context) => {
      console.error("Error deleting clearer:", err);
      if (context?.previousUsers) {
        queryClient.setQueryData(["users"], context.previousUsers);
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["users"] });
    },
  });
}

const queryClient = new QueryClient();

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Example />
      {/* <Suspense fallback={null}>
        <ReactQueryDevtoolsProduction />
      </Suspense> */}
    </QueryClientProvider>
  );
}

const validateRequired = (value: string) => !!value.length;

function validateUser(user: User) {
  const errors: Record<string, string> = {};

  if (!validateRequired(user.name)) {
    errors.name = "Clearer name is required";
  } else if (user.name.trim().length > 2000) {
    errors.name = "Clearer name must not exceed 2000 characters";
  } else if (!/^[a-zA-Z0-9\s]+$/.test(user.name.trim())) {
    errors.name = "Special characters are not allowed";
  }

  return errors;
}
